import { Route, Routes } from "react-router-dom";
import Managers from "./Managers";
import Services from "./Service";
import Subscriptions from "./Subscriptions";
import Holidays from "./Holidays";
import Equipments from "./Equipments";
import Customize from "./Customize";
import GeneralEquipments from "./GeneralEquipments";
import GlobalConfig from "./GlobalConfig";


function Admin() {

    return (
        <Routes>
            <Route path="/managers" element={<Managers />} />
            {/* <Route path="/services" element={<Services />} /> */}
            <Route path="/subscriptions" element={<Subscriptions />} />
            <Route path="/equipments" element={<Equipments />} />
            <Route path="/general_equipments" element={<GeneralEquipments />} />
            <Route path="/holidays" element={<Holidays />} />
            <Route path="/customize" element={<Customize />} />
            <Route path="/config" element={<GlobalConfig />} />
        </Routes>
    )
}

export default Admin;